<div class="container">
  <button class="btn-empty close" (click)="close()">
    <svg [icon]="icons.Close" class="dark-gray-color svg24" />
  </button>
  <div class="modal-title">Список файлов</div>
  <div class="files-wrapper">
    <app-catalog-item-card-files-info
      [filesData]="data"
    ></app-catalog-item-card-files-info>
  </div>
</div>
